// extracted by mini-css-extract-plugin
module.exports = {"smsConfirm":"style-module--smsConfirm--2s344","newPass":"style-module--newPass--33V_I"};